<template>
  <div class="pie">
    <div :id="upperRingId" class="upperRingItems" :style="{width: width, height: height}" ></div>
  </div>
</template>

<script>
  import {debounce} from '../../utils/util'
  export default {
    name: 'upper-ring',
    props: {
      upperRingId: {
        type: String,
        default () {
          return 'upperRingId'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '220px'
        }
      },
      ringTitle: {
        type: String,
        default () {
          return ''
        }
      },
      ringLegend: {
        type: Object,
        default () {
          return {
            left: 'center',
            bottom: 5,
          }
        }
      },
      colorList: {
        type: Array,
        default () {
          return ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
        }
      },
      series: {
          type: Array,
          default () {
              return []
          }
      }
    },
    data () {
      return {
        upperRingItems: null
      }
    },
    created () {},
    mounted () {
      this.drawPie()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      drawPie () {
        this.upperRingItems = this.$echarts.init(document.getElementById(this.upperRingId))
        this.upperRingItems.setOption({
          title : {
            text: this.ringTitle,
            trigger: 'item',
            left: 'center',
            formatter: '{a} <br/>{b}: {c} ({d}%)',
            titleStyle: {
              color: '#333333'
            }
          },
          tooltip : {
            trigger: 'item',
            // formatter (data) {
            //   return `${data.name}:${data.value}`
            // },
            formatter: `{b} : {c} ({d}%)`,
          },
          grid: {
            left: '0',
            right: '0',
            top: '0',
            bottom: '0',
            containLabel: true
          },
          legend: this.ringLegend,
          color: this.colorList,
          series: this.series
        });

      },

      resizeChart: debounce(function () {
        this.upperRingItems.resize()
      }, 100)
    },
    watch: {
      series () {
        this.drawPie()
      }
    }
  }
</script>

<style scoped lang="less">
  .pie {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .pie-right {
      width: 50%;
      display: flex;
      justify-content: center;
      flex-direction: column;
  }
  .pie-percentage {
      display: flex;
      justify-content: flex-start;
  }
  .pie-return {
      margin-bottom: 10px;
  }
  .hubei:hover {
    cursor: pointer;
    color: #5B9BD5;
  }
  .wenzhou:hover {
    cursor: pointer;
    color: #ED7D31;
  }
  .taizhou:hover {
    cursor: pointer;
    color: #FFC000;
  }
  .ningbo:hover {
    cursor: pointer;
    color: #A5A5A5;
  }
</style>



// WEBPACK FOOTER //
// src/components/UpperEcharts/upperRing.vue